<template>
  <div class="logon">
    <div class="wrapper fadeInDown">
      <div id="formContent">
        <div class="fadeIn first">
          <img src="@/assets/logo.png" id="icon" />
        </div>
        <form>
          <h3>Alterar Senha</h3>
          <p class="fadeIn second hint">Defina uma nova senha para continuar.</p>
          <input type="password" id="newPassword" class="fadeIn second" name="newPassword"
            placeholder="Nova senha" v-model="newPassword" minlength="6"
            @keypress.enter="changePassword">
          <input type="password" id="confirmPassword" class="fadeIn third" name="confirmPassword"
            placeholder="Confirmar senha" v-model="confirmPassword" minlength="6"
            @keypress.enter="changePassword">
          <input type="button" class="fadeIn fourth" value="Continuar" @click="changePassword"
            :disabled="loading || !newPassword || newPassword.length < 6 || newPassword !== confirmPassword">
          <div class="text-center fadeIn fourth mb-3">
            <router-link to="/login">Voltar ao login</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alterar-senha-temporaria',
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      loading: false
    };
  },
  mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.replace('/login');
      return;
    }
    this.$nextTick(() => {
      const el = document.getElementById('newPassword');
      if (el) el.focus();
    });
  },
  methods: {
    changePassword() {
      if (!this.newPassword || this.newPassword.length < 6) {
        this.$notify({ type: 'warning', message: 'A senha deve ter no mínimo 6 caracteres' });
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$notify({ type: 'warning', message: 'As senhas não coincidem' });
        return;
      }

      this.loading = true;
      this.$clubApi.post('/user/backoffice/password/change-temporary', {
        passwd: this.newPassword
      })
        .then((response) => {
          const token = response.data.object;
          if (!token) {
            this.$notify({ type: 'warning', message: 'Erro ao alterar senha' });
            return;
          }
          localStorage.setItem('token', token);
          this.$notify({ type: 'success', message: 'Senha alterada com sucesso!' });
          location.href = 'assinatura/consultar';
        })
        .catch((error) => {
          const msg = (error.response && error.response.data && error.response.data.msg)
            || 'Erro ao alterar senha';
          this.$notify({ type: 'warning', message: msg });
        })
        .finally(() => {
          this.loading = false;
          NProgress.done();
        });
    }
  }
};
</script>

<style scoped>
html {
  background-color: #2C4759;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #999;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
  margin-top: 100px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 0px;
  width: 90%;
  max-width: 450px;
  position: relative;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

h3 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 20px 8px 10px 8px;
  color: #0d0d0d;
}

.hint {
  color: #666;
  font-size: 13px;
  margin: 0 20px 10px;
}

input[type=button] {
  background-color: #2C4759;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(130, 214, 189, 0.4);
  box-shadow: 0 10px 30px 0 rgba(130, 214, 189, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover {
  background-color: #88BCC6;
}

input[type=button]:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #2C4759;
  outline: none;
}

.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@-webkit-keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first { -webkit-animation-delay: 0.4s; animation-delay: 0.4s; }
.fadeIn.second { -webkit-animation-delay: 0.6s; animation-delay: 0.6s; }
.fadeIn.third { -webkit-animation-delay: 0.8s; animation-delay: 0.8s; }
.fadeIn.fourth { -webkit-animation-delay: 1s; animation-delay: 1s; }

#icon {
  width: 60%;
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>
